<template>
  <v-autocomplete
    :items="pathologyDiagnosis || []"
    return-object
    clearable
    v-model="selectedDiagnosis"
    @input="emitDiagnosis"
    :label="component.label"
  >
  </v-autocomplete>
</template>

<script>
import { OptionDiagnosisPathology } from '@/models/Specialty'

export default {
  props: {
    component: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: undefined
    },
    organSystem: {
      type: String,
      default: undefined
    }
  },
  data() {
    return { selectedDiagnosis: this.value }
  },
  methods: {
    emitDiagnosis() {
      if (this.selectedDiagnosis) {
        this.$emit('diagnosisSelected', this.selectedDiagnosis)
        this.$emit('input', this.selectedDiagnosis.value)
      }
    }
  },
  computed: {
    pathologyDiagnosis() {
      const query = OptionDiagnosisPathology.query()

      if (this.organSystem) {
        query.where('organSystemId', this.organSystem)
      }

      return query.get()
    }
  }
}
</script>
